import * as React from "react";
import { Row, Col, message, Form, Button, List } from "antd";
import TrackedBolSearchBar from "./TrackedBolSearchBar";
import TrackedBolSearchFormHandler from "./TrackedBolSearchFormHandler";
import NotificationUtility from "Core/NotificationUtility";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { FormComponentProps } from "antd/lib/form";
import { TrackedBolSearchResults } from ".";
import AuthContext from "Context/AuthContext";
import { AddTrackedBolRequestModel, IAddTrackedBolRequestModel, AddTrackedBolResponseModel } from "Core/Api/Kopp/Api";
import moment from 'moment';
import TrackedBolSupplementaryInfoForm from "../TrackedBolSupplementaryInfoForm";

export interface Props extends FormComponentProps, RouteComponentProps {
    children?: React.ReactNode
}

export interface State {
    results: IAddTrackedBolRequestModel[],
    showDrawer: boolean,
    showResult: boolean,
    trackedBol?: IAddTrackedBolRequestModel,
}

class BaseTrackedBolSearchForm extends React.Component<Props, State> {
    static contextType = AuthContext;
    context!: React.ContextType<typeof AuthContext>;
    handler: TrackedBolSearchFormHandler;
    constructor(props: Props) {
        super(props)
        this.handler = new TrackedBolSearchFormHandler(props);

        this.state = {
            results: [],
            showDrawer: false,
            showResult: false,
        }
    }

    //remember to pass data down
    Search = (trackecBolNumber: string) => {

        this.handler.GetBillOfLading(trackecBolNumber)
            .then(async foundBol => {
                const { results } = this.state;
                if (results != undefined) {
                    const existingBol = results.filter(x => x.bolNumber?.toLowerCase().trim() === foundBol.bolNumber?.toLowerCase().trim());
                    console.log("found", foundBol);
                    var total = foundBol!.total ?? 0;


                    //check if bol already flagged in apm as click n collect
                    if (foundBol.refNumber != null) {

                        if (foundBol.isClickNGo) {
                            NotificationUtility.info(`Shipment with Bill of Lading ${foundBol.bolNumber!.toUpperCase()} already in Click N Collect `
                                , '', 30, true)
                        }
                        else {
                            let exists: Boolean = await this.trackedBolExists(foundBol.refNumber, foundBol.bolNumber!);

                            let result: IAddTrackedBolRequestModel = new AddTrackedBolRequestModel();
                            result = {
                                bolReferenceNumber: foundBol.refNumber,
                                bolNumber: foundBol.bolNumber,
                                description: foundBol.description,
                                userId: this.context.data?.id,
                                userFullName: `${this.context.data?.firstname} ${this.context.data?.lastname}`,
                                userName: this.context.data?.username,
                                mobile: this.context.data?.mobilePhone,
                                vessel: foundBol.vesselName,
                                voyage: foundBol.voyage,
                                wharehouseLocation: foundBol.wharehouseLocation,
                                arrivalDate: moment(foundBol.arrivalDate, "YYYYMMDD").toISOString(),
                                currentStatus: foundBol.currentStatus,
                                //TODO: add extra fields from endpoint
                                consigneeName: foundBol.consigneeName,
                                cargoDescription: foundBol.description,
                                shipperName:foundBol.shipperName,
                                numberOfPieces:foundBol.numberOfPieces
                            };

                            if (!exists) {

                                if (existingBol && existingBol.length > 0) {
                                    // was already in the list, updating the list
                                    const newList = results.filter(x => x.bolNumber?.toLowerCase().trim() !== foundBol.bolNumber?.toLowerCase().trim());
                                    NotificationUtility.info(
                                        'Item Already In List',
                                        `Shipment with Bill of Lading No. ${foundBol.bolNumber?.toUpperCase()} already in list below`,
                                        25,
                                        true
                                    );
                                } else {
                                    this.showDrawer(result) //call funtion to set drawer visibility to true 
                                }
                            }
                        }
                    }
                }

            })
            .catch((e) => {
                console.log("error", e)
                NotificationUtility.error('Error', 'No related BOLs found', 30, true)
            });
    }

    //checks if tracked bol already in kopp db
    trackedBolExists = async (refNumber: string, bolNumber: string) => {
        let exists;
        await this.handler.GetTrackedBolByBolReference(refNumber).then(x => {

            if (x.trackedBol != null && x.trackedBol.bolReferenceNumber == refNumber) {
                exists = true;
                NotificationUtility.info(`Shipment with Bill of Lading ${bolNumber.toUpperCase()} already in Click N Collect `
                    , '', 30, true)
            }
        })
            .catch((e) => {
                exists = false;
            });

        return exists;
    };
    //end of trackedBolExists

    listOfTrackedBols = (bols: AddTrackedBolResponseModel[]) => {
        return (
            <Row>
                <Col>
                    <List
                        size="small"
                        dataSource={bols}
                        renderItem={item =>
                            <List.Item style={{ color: "white", border: 0, margin: 0, padding: 0 }}>
                                {item.bolNumber?.toUpperCase()}
                            </List.Item>
                        }
                    />
                </Col>
            </Row>
        )
    };
    removeShipment = (cargo: IAddTrackedBolRequestModel) => {
        this.setState({ results: this.state.results.filter(f => f != cargo) });
        NotificationUtility.info('Shipment Removed', '', 30, true);
    }

    //method send passed down to TrackedBolSupplementaryInfoForm component to get supplementary info
    addTrackedBolToList = (trackedBol: IAddTrackedBolRequestModel) => {

        let existingBolIndex = this.state.results.findIndex(x => x.bolNumber == trackedBol.bolNumber);
        let newList: any[] = [];
        if (existingBolIndex != -1) {
            newList = this.state.results;
            newList[existingBolIndex] = trackedBol;
        } else {
            newList = [...this.state.results, trackedBol];
        }

        this.setState({ results: newList, showDrawer: false, trackedBol: undefined });
        this.successfulAddedtoListNotice();
    }

    addTrackedBol = () => {
        this.handler.AddTrackedBol(this.state.results).then(x => {

            if (x.failedToAddAll == true) {
                NotificationUtility.error(
                    "There was an issue.",
                    "No Bill of Lading was added to Click N Collect. Please contact the administrator.",
                    25,
                    true);
                this.props.history.push("/click-n-go");
            }
            else {
                if (x.trackedBols) {

                    let successBols = x.trackedBols.filter(x => x.successful == true);
                    let failedBols = x.trackedBols.filter(x => x.successful == false);

                    if (successBols.length != 0) {

                        NotificationUtility.success(
                            `Successfully added the following BOL(s) to Click N Collect to be tracked:`,
                            this.listOfTrackedBols(successBols),
                            25,
                            true
                        );
                    }

                    if (failedBols.length != 0) {
                        NotificationUtility.warning(
                            `Failed To Add BOL(s) To Click N Collect`,
                            this.listOfTrackedBols(failedBols),
                            25,
                            true
                        );
                    }
                    this.props.history.push("/click-n-go");
                }
            }

        })
            .catch(() => {
                NotificationUtility.error("Something went wrong", "Please contact Admin", 0, true);
            })


    }
    //end of addTrackedBol

    //buttons to open and close drawer with supplementary info form
    showDrawer = (trackedBol: IAddTrackedBolRequestModel) => {
        this.setState({ showDrawer: true, trackedBol });
    };

    //show notification when bol successfully to list (before it is sent to be tracked)
    successfulAddedtoListNotice = (title = 'Shipment Added To List', message = `Shipment ${this.state.trackedBol?.bolNumber?.toUpperCase()} was added to the list.`) => {
        NotificationUtility.success(
            title,
            message,
            20,
            true);
    }

    onCancel = () => {
        this.setState({ showDrawer: false, trackedBol: undefined });
    }


    render() {
        return (
            <Row>
                <Row style={{ marginBottom: 10 }}>
                    <Col span={2}>
                        <Button icon="arrow-left" size="small" onClick={() => this.props.history.push("/click-n-go")} type="primary">
                            Back
                        </Button>
                    </Col>
                </Row>
                <Col>
                    <Row>
                        <Col>
                            <TrackedBolSearchBar search={this.Search} />
                        </Col>
                    </Row>
                    <Row style={{ border: "solid lightgrey 2px", borderRadius: "15px", padding: "15px 20px", marginTop: "23px" }}>
                        <Row>
                            <Col>
                                <TrackedBolSearchResults removeShipment={this.removeShipment} results={this.state.results} addTrackedBol={this.addTrackedBol} onEditTrackedBol={this.showDrawer} />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                {this.state.showDrawer &&
                                    <TrackedBolSupplementaryInfoForm
                                        drawerVisible={this.state.showDrawer}
                                        trackedBol={this.state.trackedBol}
                                        onComplete={this.addTrackedBolToList}
                                        onCancel={this.onCancel}
                                    />}
                            </Col>
                        </Row>
                    </Row>
                </Col>
            </Row >
        )
    }
}

const TrackedBolSearchFormWithoutRouter = Form.create<Props>({
    name: 'TrackedBolSearchForm',
})(BaseTrackedBolSearchForm);
const TrackedBolSearchForm = withRouter(TrackedBolSearchFormWithoutRouter);
export default TrackedBolSearchForm;